export default __webpack_public_path__ + "static/media/dialogBac.4ea92e1c.png";